const CompanyNum = ({ files, onChange }) => {
  return (
    <div
      className="input_wrap file_input_wrap"
      style={{ backgroundColor: "white", height: "40px" }}
    >
      <input
        className="input_box file_input"
        type="file"
        id="file"
        style={{ visibility: "hidden", width: "150px" }}
        onChange={onChange}
      />
      <label htmlFor="file" className="file_label" style={{ height: "100%" }}>
        사업자 등록증
      </label>
      {files[0]?.name === undefined ? (
        <h5 style={{ width: "100%" }}>파일을 선택해주세요</h5>
      ) : (
        <h5 style={{ width: "100%" }}>{files[0]?.name}</h5>
      )}
    </div>
  );
};
export default CompanyNum;
